import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://dev.api.schenck.one',
  apiBaseUrl: 'https://dev.api.schenck.one/rc/api/v1', // against deployed/cloud backend
  usBaseUrl: 'https://dev.api.schenck.one/user', //  for user settings api
  umBaseUrl: 'https://dev.api.schenck.one/um/v2/rights/RC',
  amBaseUrl: 'https://dev.api.schenck.one/am/v1', // against deployed/cloud backend
  apiVersion: '1.0',
  versionInfo: {
    tag: 'dev',
    hash: '74d598c78c064e05e0e72721b443d2024f82a46c',
    buildtimestamp: '2026-07-06T06:33:22.5964927Z',
    buildVersion: '3.0.0+4381',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: 'dd4401ed-b143-4139-a709-a4b7452dc24e',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://dev.reportcenter.schenck.one',
        postLogoutRedirectUri: 'https://dev.reportcenter.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/ed79441b-4a58-4429-b5cd-233d0f88de57/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
